<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.GpExplain')"
    width="450px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form label-position="left" label-width="75px">
      <el-form-item :label="$t('FinanceManage.GpExplain')">
        <cargo-advance-select
          no="GpExplainTitle"
          :select-type="selectTypeNames.basic_data_GpExplainTitle"
          filterable
          :clearable="false"
          :default-value="form.code"
          @parentCallBack="p=>{form.code=p.value;}"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="7"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="btnConfirm">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { batchAddGpExplainRecord } from '@/api/booking/gpExplainRecord'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'AddGpExplainDialog',
  components: { cargoAdvanceSelect },
  props: {
    type: { type: String, required: true },
    visible: { type: Boolean, required: true },
    jobUuids: { type: Array, required: true }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      innerVisible: false,
      form: {
        code: '',
        remark: ''
      }
    }
  },
  computed: {
    selectTypeNames() {
      return selectTypeNames
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async btnConfirm() {
      // 组装参数
      const param = {
        'jobUuids': this.jobUuids,
        'code': this.form.code,
        'remark': this.form.remark
      }
      const loading = getLoading()
      // 调用接口保存
      const resp = await batchAddGpExplainRecord(param).finally(() => loading.close())
      if (resp.ok && resp.data >= 0) {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        if (this.type === 'detail') {
          // 刷新外部方法
          this.$emit('callback')
        }
        this.innerVisible = false
      } else {
        this.$message.warning(this.$t('SeaExport.OperationFailed'))
      }
    }
  }
}
</script>
